









































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TipoDeOperacao } from '@/models/Recurso'
import type { TipoDeRecurso } from '@/models/Recurso'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'

@Component
export default class DataTableDeCrud extends Vue  {
	@Prop({ type: String, default: 'Criar Novo' }) tituloParaCriar!: string
	@Prop({ type: Boolean, default: false }) carregandoCriar!: boolean
	@Prop({ type: Boolean, default: false }) hideActions!: boolean
	@Prop({ type: Boolean, default: false }) hideUpdate!: boolean
	@Prop({ type: Boolean, default: false }) hideDelete!: boolean
	@Prop({ type: Boolean, default: false }) hideCreate!: boolean
	@Prop({ type: Boolean, default: false }) hideUpdateProdutoPai!: boolean
	@Prop({ type: String }) recurso?: TipoDeRecurso
	@Prop({ type: Boolean, default: true }) hideDetail!: boolean
	@Prop({ type: Boolean, default: false }) podeCopiar!: boolean
	@Prop({ type: [Boolean, Function], default: false }) readonly podeRedirecionarVenda!: boolean | ((item: any) => boolean)
	@Prop({ type: [String, Function], default: 'mdi-pencil' }) readonly iconeAlterar!: string | ((item: any) => string)
	@Prop({ type: Number, default: -1 }) indiceDeletando!: number

	get recursoNormalizado() {
		return this.recurso || this.$route.meta?.recurso
	}

	get podeCriar() {
		if (this.hideCreate) return false
		return this.podeRealizarOperacao('criar')
	}

	get podeAlterar() {
		if (this.hideUpdate) return false
		return this.podeRealizarOperacao('alterar')
	}

	get podeDeletar() {
		if (this.hideDelete) return false
		return this.podeRealizarOperacao('deletar')
	}

	get podeAlterarEmMassa() {
		if (this.hideUpdateProdutoPai) return true

		return false
	}

	get headersNormalizado() {
		return this.hideActions
			? [...this.$attrs.headers]
			: [
				...this.$attrs.headers,
				{ text: 'Ações', value: 'actions', sortable: false, align: 'center' },
			]
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return !this.recursoNormalizado || UserLoginStore.temAutorizacao(
			montarOperacaoDeRecurso(operacao, this.recursoNormalizado),
		)
	}

	deveMostrarBotaoRedirecionar(item: any) {
		if (typeof this.podeRedirecionarVenda === 'function') {
			return this.podeRedirecionarVenda(item)
		}
		return !!this.podeRedirecionarVenda
	}

	obterIconeAlterar(item: any) {
		return typeof this.iconeAlterar === 'function'
			? this.iconeAlterar(item)
			: this.iconeAlterar
	}
}

